export const errorSelector = (stateSlice) => (state) => state[stateSlice].error;

export const loadingSelector = (state) => state.appState.loading;

export const successActionSelector = (state) => state.appState.successAction;
